export default {
  AtivacaoCarteira: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "ativacao-carteira"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/AtivacaoCarteira.js
// module id = egfx
// module chunks = 18